import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="social-links">
            <a href="https://www.facebook.com/marco.demarco" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fab fa-facebook-f"></i>
              <span>Facebook</span>
            </a>
            <a href="https://twitter.com/MarcoPDeMarco" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fab fa-twitter"></i>
              <span>Twitter</span>
            </a>
            <a href="https://www.instagram.com/marcodeman/" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fab fa-instagram"></i>
              <span>Instagram</span>
            </a>
            <a href="https://www.linkedin.com/in/marcodemarco/" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fab fa-linkedin-in"></i>
              <span>LinkedIn</span>
            </a>
            <a href="https://www.youtube.com/user/MarcoDeMarco11/" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fab fa-youtube"></i>
              <span>YouTube</span>
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 MarcoDeMarco&trade; ~ All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
